
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { SearchX } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Sprawdź, czy jesteśmy na oryginalnej domenie lub czy URL zawiera www.
    const hostname = window.location.hostname;
    if (hostname !== 'czuleklisze.pl' && !hostname.includes('localhost') && !hostname.includes('127.0.0.1')) {
      console.error(`404 Błąd: Nieprawidłowa domena: ${hostname}`);
    } else {
      console.error(
        "404 Błąd: Użytkownik próbował uzyskać dostęp do nieistniejącej trasy:",
        location.pathname
      );
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="flex justify-center">
          <div className="bg-amber-100 p-3 rounded-full">
            <SearchX className="h-12 w-12 text-amber-500" />
          </div>
        </div>
        <h1 className="text-4xl font-serif font-bold text-gray-900">404</h1>
        <h2 className="text-2xl font-medium text-gray-800">Strona nie znaleziona</h2>
        <p className="text-gray-600">
          Przepraszamy, nie możemy znaleźć strony, której szukasz. Możliwe, że adres URL
          został zmieniony lub strona została usunięta.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button 
            onClick={() => navigate("/")}
            variant="default"
          >
            Wróć do strony głównej
          </Button>
          <Button 
            onClick={() => navigate(-1)}
            variant="outline"
          >
            Powrót do poprzedniej strony
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
